// Mobile menu
(function() {
  var dots = document.getElementById('nav-dots');
  var menu = document.getElementById('mobile-menu');
  var closeBtn = document.getElementById('mobile-menu-close');
  if (!dots || !menu) return;
  function open() { menu.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function close() { menu.classList.remove('open'); document.body.style.overflow = ''; }
  dots.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  menu.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', close); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && menu.classList.contains('open')) close();
  });
})();

// Mobile submenu toggle
(function() {
  var toggle = document.getElementById('mobile-learn-toggle');
  var sub = document.getElementById('mobile-learn-sub');
  if (!toggle || !sub) return;
  toggle.addEventListener('click', function() {
    toggle.classList.toggle('open');
    sub.classList.toggle('open');
  });
})();

// Accordions (benefits + FAQ)
document.querySelectorAll('.benefit-trigger, .faq-trigger').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var item = btn.parentElement;
    var siblings = item.parentElement.children;
    var wasOpen = item.classList.contains('open');
    Array.from(siblings).forEach(function(s) { s.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  });
});

// Story modal (Cloudflare Stream)
(function() {
  var modal = document.getElementById('story-modal');
  if (!modal) return;
  var closeBtn = document.getElementById('story-modal-close');
  var videoSlot = document.getElementById('story-modal-video');
  var quoteEl = document.getElementById('story-modal-quote');
  var attrEl = document.getElementById('story-modal-attr');
  var STREAM_BASE = 'https://customer-asjbqska58sohwum.cloudflarestream.com/';

  function openStory(card) {
    var uid = card.getAttribute('data-video-uid');
    var name = card.getAttribute('data-name');
    var quote = card.getAttribute('data-quote');
    if (uid) {
      videoSlot.innerHTML = '<iframe src="' + STREAM_BASE + uid + '/iframe?autoplay=true" style="width:100%;height:100%;border:none" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>';
    }
    quoteEl.textContent = '\u201C' + quote + '\u201D';
    attrEl.textContent = '\u2014 ' + name;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeStory() {
    modal.classList.remove('open');
    videoSlot.innerHTML = '';
    document.body.style.overflow = '';
  }
  document.querySelectorAll('.story-card').forEach(function(card) {
    card.addEventListener('click', function() { openStory(card); });
  });
  if (closeBtn) closeBtn.addEventListener('click', closeStory);
  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeStory();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) closeStory();
  });

  // Auto-open a story from URL param: ?story=peter or ?story=<uid>
  try {
    var params = new URLSearchParams(window.location.search);
    var storyQ = (params.get('story') || '').trim().toLowerCase();
    if (storyQ) {
      var target = null;
      document.querySelectorAll('.story-card').forEach(function(card) {
        var uid = (card.getAttribute('data-video-uid') || '').toLowerCase();
        var name = (card.getAttribute('data-name') || '').toLowerCase();
        if (uid === storyQ || name === storyQ) target = card;
      });
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function() { openStory(target); }, 500);
      }
    }
  } catch (e) {}
})();